import { render, staticRenderFns } from "./VehicleDescription.vue?vue&type=template&id=55c01820&"
import script from "./VehicleDescription.vue?vue&type=script&lang=js&"
export * from "./VehicleDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports